/**
 * @desc 直接审批通过会员企业认证
 */
import {
  AuditEnterpriseEntity,
  AuditEnterpriseForm
} from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type AuditPassEnterpriseParameter = AuditEnterpriseForm

const method = 'POST'
const url = '/auth/audit/enterprise/auditPass'

export const auditPassEnterpriseApi = (
  data?: AuditPassEnterpriseParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuditEnterpriseEntity>({
    method,
    url,
    data,
    ...config
  })
}

auditPassEnterpriseApi.method = method
auditPassEnterpriseApi.url = url
